import {
    Box,
    Heading,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
} from '@ksyos/design-system';
import { DisplayAmountWithVatRate } from '@frontend/components/elements/displayAmountWithVatRate';
import { NullableFormattedDate } from '@frontend/components/elements/NullableFormattedDate';
import { getSelectedLanguage } from '@frontend/translate';
import type { SingularPatientInvoice } from '../adminProcessDetailsTypes';

type SingularPatientInvoicesProps = {
    label: string;
    singularPatientInvoices: SingularPatientInvoice[];
};

export function SingularPatientInvoices({
    singularPatientInvoices,
    label,
}: Readonly<SingularPatientInvoicesProps>): JSX.Element | null {
    if (singularPatientInvoices.length === 0) {
        return null;
    }

    const translate = getSelectedLanguage();

    return (
        <Box marginBottom={3}>
            <Heading
                as="h3"
                fontWeight="bold"
                marginBottom={1}
                size="small"
            >
                {label}
            </Heading>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableHeader>{translate.finance.activityDate}</TableHeader>
                            <TableHeader>{translate.finance.amount}</TableHeader>
                            <TableHeader>{translate.export.runDate}</TableHeader>
                            <TableHeader>{translate.export.runNumber}</TableHeader>
                            <TableHeader>{translate.finance.counterBooking}</TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {singularPatientInvoices.map((singularPatientInvoice) => (
                            <TableRow key={singularPatientInvoice.id}>
                                <TableCell>
                                    <NullableFormattedDate value={singularPatientInvoice.activityDate} />
                                </TableCell>
                                <TableCell>
                                    {singularPatientInvoice.amount !== null && (
                                        <DisplayAmountWithVatRate amountWithVatRate={singularPatientInvoice} />
                                    )}
                                </TableCell>
                                <TableCell>
                                    <NullableFormattedDate value={singularPatientInvoice.runDate} />
                                </TableCell>
                                <TableCell>{singularPatientInvoice.runNumber}</TableCell>
                                <TableCell>{singularPatientInvoice.counterBookingId ? 'TB' : null}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}
